<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7pH3e4/tc-custom/9781479809882.jpg?1728851932667" alt="This image is the cover for the book Civil Religion Today"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Civil Religion Today
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Moves the discussion of American civil religion into the twenty-first century </b><br/><br/>Civil Religion, a term made popular by sociologist Robert Bellah a little over fifty years ago, describes how people might share in a sacred sense of their nation. While hotly debated, the idea continues to enjoy wide application among academics and journalists. Bellah used civil religion to make sense of the turmoil of the 1960s, especially moral debates provoked by the Vietnam War. Now, a half-century later, American society is again riven by conflict over immigration, economic inequality, racial oppression, and “culture wars” issues. Is Bellah's hopeful assessment still useful for understanding contemporary America? If not, how should we think of it differently?<br/><br/><i>Civil Religion Today</i> reassesses the term to take stock of its usefulness after fifty years of engagement in the field. Looking both at the concept and at ground-level studies of how we might find civil religion in practice, this book aims to push the conversation forward, considering how and in what ways it is helpful in our current social and political context, evaluating which parts are worth keeping, which can be reformulated, and which can now be usefully discarded. It suggests we go “beyond Bellah” in theory and practice, thinking about American society in a new century.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rhys H. Williams, Raymond Haberski, Philip Goff
      </h2>
      
      <p class="authorDescription body article"><B>Rhys H. Williams (Editor) </B><br><B>Rhys Williams </B>is Professor of Sociology and Department Chair Director of the McNamara Center for the Social Study of Religion at Loyola University Chicago. He is coauthor or editor of three books, including <I>Civil Religion Today: Religion and the American Nation in the Twenty-First Century</I> (NYU Press, 2021), <I>The Urban Church Imagined: Religion, Race, and Authenticity in the City</I> (New York University Press, 2017) and <I>Religion and Progressive Activism: New Stories about Faith and Politics</I> (New York University Press, 2017).<B></B><br><br><B>Raymond Haberski Jr. (Editor) </B><br><B>Raymond J. Haberski, Jr.</B> is Professor of History and American Studies at Indiana University-Purdue University Indianapolis.<br><br><B>Philip  Goff (Editor) </B><br><B>Philip Goff</B> is Director of the Center for the Study of Religion and American Culture and Chancellor’s Professor of American Studies and Religious Studies at Indiana University-Purdue University Indianapolis.<br><br></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New York University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?dbdee8fa